import { useReducer } from 'react';
import { RcsTemplateEditorReducer } from './RcsTemplateEditorReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  RcsTemplateEditorDispatchContext,
  RcsTemplateEditorStateContext,
} from './useRcsTemplateEditorContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface IRcsTemplateEditorProviderProps {
  children: React.ReactNode;
  value?: IValue;
}

export function RcsTemplateEditorProvider({
  children,
  value = { initialState: defaultContextValues, reducer: RcsTemplateEditorReducer },
}: IRcsTemplateEditorProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <RcsTemplateEditorStateContext.Provider value={state}>
      <RcsTemplateEditorDispatchContext.Provider value={dispatch}>{children}</RcsTemplateEditorDispatchContext.Provider>
    </RcsTemplateEditorStateContext.Provider>
  );
}
